window.EVENT_COURSE_BUFFER_REFRESHED = "course:buffer_refreshed";
window.EVENT_COURSE_SEQUENCE_TERMINATED = "sequence:terminate";

export const CourseEvents = {
    BUFFER_REFRESHED: window.EVENT_COURSE_BUFFER_REFRESHED,
    COURSE_REFRESH: "course:refresh",
    SEQUENCE_TERMINATED: window.EVENT_COURSE_SEQUENCE_TERMINATED
};
